export const ALERT_ACTION_TYPES = {
    TRIGGER: 'ALERT_TRIGGER',
    CLEAR: "ALERT_CLEAR"
}
export const SIDENAV_ACTION_TYPES = {
    TOGGLE: 'SIDENAV_TOGGLE'
}

export const POPUP_ACTION_TYPES = {
    TOGGLE: 'TOGGLE_POPUP'
}

export const USER_ACTION_TYPES = {
    GET_USER_DETAIL: 'GET_USER_DETAIL',
    GET_USER_PLANTS: 'GET_USER_PLANTS',
    GET_USER_LIST: 'GET_USER_LIST',
    CREATE_USER: 'CREATE_USER',
    GET_USER_ROLE_LIST: 'GET_USER_ROLE_LIST',
    ASSIGN_USER_ROLES: 'ASSIGN_USER_ROLES',
    ASSIGN_USER_FACTORIES: 'ASSIGN_USER_FACTORIES',
}

export const IE_DISTRIBUTION_ACTION_TYPES = {
    GET_IE_DISTRIBUTION_LIST: 'GET_IE_DISTRIBUTION_LIST',
    ADD_OR_UPDATE_IE_DISTRIBUTION: 'ADD_OR_UPDATE_IE_DISTRIBUTION',
    GET_IE_DISTRIBUTION: 'GET_IE_DISTRIBUTION',
    DELETE_IE_DISTRIBUTION: 'DELETE_IE_DISTRIBUTION',
    UPDATE_PER_WEEK_HOURS: 'UPDATE_PER_WEEK_HOURS'
}

export const STUDY_BROWSER_ACTIONS = {
    GET_STUDY_BROWSER_LIST: 'GET_STUDY_BROWSER_LIST',
    UPDATE_STUDY_BROWSER_LIST: 'UPDATE_STUDY_BROWSER_LIST',
    GET_STUDY_BROWSER_DETAIL: 'GET_STUDY_BROWSER_DETAIL',
    ADD_STUDY_OPERATION_COMMENT: 'ADD_STUDY_OPERATION_COMMENT'
}

export const FACTORY_ACTION_TYPES = {
    GET_SBU_LIST: 'GET_SBU_LIST',
    GET_PLANT_LIST: 'GET_PLANT_LIST',
    GET_MODULE_LIST: 'GET_MODULE_LIST',
    GET_FACTORY_LIST: 'GET_FACTORY_LIST',
    CREATE_FACTORY: 'CREATE_FACTORY',
    GET_MODULE_BY_FACTORY_CODE: 'GET_MODULE_BY_FACTORY_CODE'
}

export const SHIFT_ACTION_TYPES = {
    GET_SHIFT_LIST: 'GET_SHIFT_LIST'
}

export const OPERATIONMASTER_ACTION_TYPES = {
    GET_OPERATIONMASTER_LIST: 'GET_OPERATIONMASTER_LIST'
}

export const OPERATORMASTER_ACTION_TYPES = {
    GET_OPERATORMASTER_LIST: 'GET_OPERATORMASTER_LIST'
}

export const COMMON_ACTION_TYPES = {
    REQUEST: "_REQUEST",
    SUCCESS: "_SUCCESS",
    ERROR: "_ERROR",
    CLEAR: "_CLEAR",
};

export const REPORT_ACTIONS = {
    GET_TOTAL_CYCLE_TIME: 'GET_TOTAL_CYCLE_TIME',
    GET_PACE_MAKER: 'GET_PACE_MAKER',
    GET_BI_REPORT: 'GET_BI_REPORT',
    GET_PLAN_OR_SBU_WISE_CYCLE_AND_BEST_CT_REPORT: 'GET_PLAN_OR_SBU_WISE_CYCLE_AND_BEST_CT_REPORT'
};

export const PRE_STUDY_ACTIONS = {
    GET_STYLES: 'GET_STYLES',
    GET_PRE_ACTIVITY_STUDY: 'GET_PRE_ACTIVITY_STUDY',
    ADD_PRE_ACTIVITY_STUDY: 'ADD_PRE_ACTIVITY_STUDY',
    UPDATE_PAGE_STATE: 'UPDATE_PAGE_STUDY',
    SET_PRE_STUDY_HEADER_DETAIL: 'SET_PRE_STUDY_HEADER',
    SET_PRE_STUDY_HEADER_ACTIVITY_DETAILS: 'SET_PRE_STUDY_HEADER_ACTIVITY_DETAILS',
    GET_PRE_ACTIVITY_STUDY_GSD_CODES: 'GET_PRE_ACTIVITY_STUDY_GSD_CODES',
    GET_PRE_ACTIVITY_STUDY_OPERATIONS: 'GET_PRE_ACTIVITY_STUDY_OPERATIONS',
    GET_PRE_ACTIVITY_STUDY_ELEMENT_CATEGORY: 'GET_PRE_ACTIVITY_STUDY_ELEMENT_CATEGORY',
    GET_PRE_ACTIVITY_STUDY_ELEMENT_NAME: 'GET_PRE_ACTIVITY_STUDY_ELEMENT_NAMES'
}